<div id="map" #map [style.min-height]="height" [style.width]="width" [ngClass]="{disabled: isDisabled}"></div>
